import React from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

function MyLinks(){
    const mylinks_dev = [
        {
            link : "https://github.com/ViLinh27",
            linkName:"github",
            iconImg : "../../assets/images/sticker-links/link-img_github.png"
        },
        {
            link : "https://linh-is-tibia.itch.io",
            linkName:"itch.io",
            iconImg : "../../assets/images/sticker-links/link-img_itchio.png"
        },
        {
            link : "https://codepen.io/vilinh27",
            linkName:"codepen",
            iconImg : "../../assets/images/sticker-links/link-img_codepen.png"
        },
        {
            link:"https://vilinh27.github.io",
            linkName:"Main Multi discipline portfolio",
            iconImg:"../../assets/images/sticker-links/link-mainportfolio.png"
        }
    ]
    const mylinks_art = [
        {
            link : "https://vgen.co/linh_is_tibia",
            linkName:"Vgen",
            iconImg : "../../assets/images/sticker-links/link-img_vgen.png"
        },
        {
            link : "https://www.youtube.com/@tibia-the-dog",
            linkName:"Youtube",
            iconImg : "../../assets/images/sticker-links/link-img_youtube.png"
        },
        {
            link : "https://www.redbubble.com/people/tibia-the-dog/shop",
            linkName:"Red bubble",
            iconImg : "../../assets/images/sticker-links/link-img_redbubble.png"
        },
        {
            link:"",
            linkName:"My Writing Website",
            iconImg:"../../assets/images/sticker-links/link-img_writing.png"
        },
        {
            link:"https://www.wattpad.com/user/TibiaWrites",
            linkName:"Wattpad",
            iconImg:"../../assets/images/sticker-links/wattpadsticker.png"
        }
    ]
    const mylinks_socials = [
        {
            link : "https://www.instagram.com/linh_is_tibia/",
            linkName:"Instagram",
            iconImg : "../../assets/images/sticker-links/link-img_insta.png"
        },
        {
            link : "https://www.threads.net/@linh_is_tibia",
            linkName:"Threads",
            iconImg : "../../assets/images/sticker-links/link-img_threads.png"
        },
        {
            link : "https://bsky.app/profile/linh-is-tibia.bsky.social",
            linkName:"Bluesky",
            iconImg : "../../assets/images/sticker-links/link-img_bluesky.png"
        },
        {
            link : "https://ko-fi.com/linhistibia",
            linkName:"kofi",
            iconImg : "../../assets/images/sticker-links/link-img_kofi.png"
        },
    ]
    return(
        <>
            <div className="MyLinks-maincontent">
                <Typography variant="h1">Check out more of my stuff :D</Typography>
                <br/>
                <div className="MyLinks-container">
                    <ul className="MyLinks-list">
                        {mylinks_art.map((item,i)=>(
                            <Button className="linkList-Btn" href={item.link} key={i}>
                                <img src={item.iconImg} alt={item.linkName}/>
                                <p>{item.linkName}</p>
                            </Button>
                        ))}
                    </ul>
                    <ul className="MyLinks-list">
                        {
                            mylinks_dev.map((item,i)=>(
                                <Button className="linkList-Btn" href={item.link} key={i}>
                                    <img src={item.iconImg} alt={item.linkName}/>
                                    <p>{item.linkName}</p>
                                </Button>
                            ))
                        }
                    </ul>
                    <ul className="MyLinks-list">
                        {
                            mylinks_socials.map((item,i)=>(
                                <Button className="linkList-Btn" href={item.link} key={i}>
                                    <img src={item.iconImg} alt={item.linkName}/>
                                    <p>{item.linkName}</p>
                                </Button>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </>
    );
}

export default MyLinks;